import styled from "styled-components";
import { MobileNavbar } from "components/shared/navbars";

const StyledHeader = styled(MobileNavbar)`
  width: 100vw;
`;
export const ToolStoreHeader = () => {
  return <StyledHeader />;
};
